import { ref, onMounted, onUnmounted, type Ref } from 'vue'

export const useScrollReveal = (options: IntersectionObserverInit = { threshold: 0.1 }) => {
    const isVisible = ref(false)
    const elementRef: Ref<HTMLElement | null> = ref(null)

    let observer: IntersectionObserver | null = null

    onMounted(() => {
        if (!elementRef.value) return

        observer = new IntersectionObserver(([entry]) => {
            if (entry?.isIntersecting) {
                isVisible.value = true
                // Once visible, we can stop observing if we only want one-time animation
                if (observer && elementRef.value) {
                    observer.unobserve(elementRef.value)
                }
            }
        }, options)

        observer.observe(elementRef.value)
    })

    onUnmounted(() => {
        if (observer) observer.disconnect()
    })

    return {
        elementRef,
        isVisible
    }
}
